import Time from '../src/Time/index.tsx';
export default Time;
